jQuery(document).ready(function ($) {
  var isScrolling = false;
  var hasSearched = false; // Add a flag to track if the search has been performed
  $(".magazine-article__search-results").append('<div id="loading-overlay"> <div>Loading Articles</div></div>');

  function scrollToTop() {
    if (!isScrolling) {
      isScrolling = true;
      $("html, body").animate({ scrollTop: "60px" }, "300", function () {
        isScrolling = false;
      });
    }
  }

  function getAllArticles(page = 1, scrollAfterLoad = false) {
    var searchQuery = $("#search-query").val();
    var postType = $('[name="post_type"]').val();
    // Show loading overlay
    $("#loading-overlay").show();
    $.ajax({
      url: ajax_object.ajax_url,
      type: "POST",
      data: {
        action: "custom_ajax_search",
        security: ajax_object.nonce,
        "search-query": searchQuery,
        post_type: postType,
        page: page,
      },
      success: function (response) {
        if (response.success) {
          $(".magazine-article__search-results").html(response.data.html);
          // Re-append the loading overlay as it was removed when replacing the HTML
          $(".magazine-article__search-results").append($("#loading-overlay"));
          updatePagination(response.data.total_pages, response.data.current_page);

          // Update and show the result counter only if search has been performed
          if (hasSearched) {
            $(".magazine-article__count-results")
              .html("Found " + response.data.total_posts + " result" + (response.data.total_posts === 1 ? "" : "s") + ' for "' + response.data.search_query + '"')
              .show();
          }

          // Wait for images to load
          var $images = $(".magazine-article__search-results img");
          var loadedImages = 0;

          if ($images.length === 0) {
            // If there are no images, hide overlay immediately
            $("#loading-overlay").hide();
            $(".magazine-issue__grid-wrapper").addClass("fade-in-up");
            if (scrollAfterLoad) scrollToTop();
          } else {
            $images
              .on("load", function () {
                loadedImages++;
                if (loadedImages === $images.length) {
                  // All images have loaded
                  $("#loading-overlay").hide();
                  $(".magazine-issue__grid-wrapper").addClass("fade-in-up");
                  if (scrollAfterLoad) scrollToTop();
                }
              })
              .each(function () {
                // Trigger load event for cached images
                if (this.complete) $(this).trigger("load");
              });
          }
        } else {
          $(".magazine-article__search-results").html("<p>Error occurred. Please try again.</p>");
          $("#loading-overlay").hide();
          if (scrollAfterLoad) scrollToTop();
        }
      },
      error: function (xhr, status, error) {
        console.error(error);
        $(".magazine-article__search-results").html("<p>Error occurred. Please try again.</p>");
        $("#loading-overlay").hide();
        if (scrollAfterLoad) scrollToTop();
      },
    });
  }

  function updatePagination(totalPages, currentPage) {
    var paginationHtml = "";
    if (totalPages > 1) {
      paginationHtml += '<div class="pagination latest-news__pagination">';

      // Previous button
      if (currentPage > 1) {
        paginationHtml += '<a href="#" class="page-nav prev" data-page="' + (currentPage - 1) + '"><p class="pagination-text">Previous</p></a>';
      }

      // Calculate start and end pages
      var startPage = Math.max(1, currentPage - 1);
      var endPage = Math.min(totalPages, startPage + 2);

      // Adjust startPage if endPage is at the limit
      if (endPage === totalPages) {
        startPage = Math.max(1, endPage - 2);
      }

      // Add page numbers
      for (var i = startPage; i <= endPage; i++) {
        if (i === currentPage) {
          paginationHtml += '<span class="page-number current">' + i + "</span>";
        } else {
          paginationHtml += '<a href="#" class="page-number" data-page="' + i + '">' + i + "</a>";
        }
      }

      // Last page
      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          var nextJumpPage = Math.min(totalPages, currentPage + 3);
          paginationHtml += '<a href="#" class="ellipsis" data-page="' + nextJumpPage + '">...</a>';
        }
        paginationHtml += '<a href="#" class="page-number" data-page="' + totalPages + '">' + totalPages + "</a>";
      }

      // Next button
      if (currentPage < totalPages) {
        paginationHtml += '<a href="#" class="page-nav next" data-page="' + (currentPage + 1) + '"> <p class="pagination-text">Next</p></a>';
      }

      paginationHtml += "</div>";

      // Add "Latest Issue" button if not on the first page
      if (currentPage > 2) {
        paginationHtml += '<div class="back-to-first"><a href="#" class="page-nav latest-issue" data-page="1"><p class="pagination-text">Latest Articles</p></a></div>';
      }
    }
    $(".magazine-past__pagination").html(paginationHtml);

    // Bind click events for the pagination links
    $(".page-number:not(.current), .page-nav, .ellipsis").on("click", function (e) {
      e.preventDefault();
      var page = $(this).data("page");
      if (page !== currentPage) {
        currentPage = page;
        getAllArticles(page, true);
      }
    });
  }

  $("#ajax-search-form").on("submit", function (e) {
    // Set the flag to true when search is performed
    hasSearched = true;
    e.preventDefault();
    getAllArticles(1, false);
  });
  // Initial load
  getAllArticles(1, false);
});
